/**
 * Shared Filter Type Definitions
 *
 * This file contains shared type definitions and enums for filters used across multiple features.
 * These are shared across orders, leads, and potentially other features.
 */

/**
 * Common date range filter for historical data
 * Used for filtering records by creation date, last updated date, order date, etc.
 */
export enum CommonDateFilter {
	TODAY = 'today',
	LAST_7_DAYS = 'last-7-days',
	LAST_30_DAYS = 'last-30-days',
	PLUS_30_DAYS = '30-plus-days',
	CUSTOM = 'custom',
}
